<template>
	<div class="login-page" v-title data-title="和华利盛">
		<div class="login-page-bg">
			<div class="login-page-bg-img">

			</div>
			<div class="login-page-bg-from">
				<h1>欢迎登陆</h1>
				<h3>欢迎登录上海和华利盛律师事务所</h3>
				<el-form ref="form" :model="form" :rules="rules" label-width="80px" :hide-required-asterisk="true">
					<el-form-item prop="userName" label="用户名：">
						<el-input placeholder="请录入用户名" v-model="form.userName"></el-input>
					</el-form-item>
					<el-form-item prop="passWord" label="密码：">
						<el-input placeholder="请录入密码" type="password" v-model="form.passWord"></el-input>
					</el-form-item>
					<el-form-item class="loginBtn" style="font-size: 12px;">
						<el-button style="width: 100%;font-size: 16px;" type="primary" :loading="loading" @click="submit">
							登录</el-button>
					</el-form-item>
				</el-form>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		name: "Login",
		data() {
			return {
				form: {
					userName: '',
					passWord: '',
				},
				loading: false,
				rules: {
					userName: [{
						required: true,
						message: '请录入用户名'
					}],
					passWord: [{
						required: true,
						message: '请录入登录密码'
					}],
				}
			}
		},
		methods: {
			submit() {
				this.$refs['form'].validate(valid => {
					if (valid) {
						// console.log(this.form)
						this.loading = true
						//执行登录操作
						this.$store.dispatch('login', this.form).then(() => {
							setTimeout(()=>{
								//执行页面跳转
								this.$router.push('/adminIndex')
							}, 500);
							this.$notify({
								type: 'success',
								title: '登录成功',
								duration: 5000,
								message: '欢迎'+this.form.userName+'回来！',	
							})
						}).catch(error => {
							this.loading = false
							this.$message.error(error)
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.loginBtn /deep/ .el-form-item__content{
		margin-left: 0px;
		margin-top: 10px;
	}
	.loginBtn /deep/ .el-button--primary{
		width: 100%;
    font-size: 16px;
    height: 60px;
    border-radius: 30px;
    background-color: #3A64FE;
    border-color: #3A64FE;
	}

	div /deep/ .el-form-item__label{
		line-height: 60px;
	}
	div /deep/ .el-form{
		margin-left: 60px;
	}

	div /deep/ .el-input__inner{
		line-height: 60px;
		height: 60px;
	}

	div /deep/ .el-form-item{
		margin-bottom: 40px;
	}

	.login-page {
		height: 100%;
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/bigBackground.png") no-repeat;
		background-size: cover;
	}

	.login-page-bg {
		position: absolute;
		top: 10%;
		left: 10%;
		right: 10%;
		bottom: 10%;
		background-color: #EBEEF8;;
		/* padding-top: 20px; */
		text-align: center;
		color: #444444;
		padding-right: 70px;
		border-radius: 10px;
		-webkit-box-shadow: #666 0px 0px 10px;
		-moz-box-shadow: #666 0px 0px 10px;
		box-shadow: #666 0px 0px 10px;

	}

	.login-page-bg-img{
		margin-top: -1px;
		float:left;
		width:60%;
		height: calc(100% + 1px);
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/smallBackground.png") no-repeat;
		background-size: cover;
	}

	.login-page-bg-from{
		float:left;
		width:40%;
		height:100%;
	}

	.login-page-bg h1 {
		margin-bottom: 20px;
    margin-left: 70px;
    text-align: left;
    margin-top: 25%;
    font-size: 50px;
	}

	.login-page-bg h3 {
		margin-left: 70px;
    text-align: left;
    color: #7F7F7F;
    margin-bottom: 42px;
		font-weight: 400;
	}
</style>
